import axios from "../axios";
const END_POINT = "/system-configs";

const changeDuration = ({ configId, payload }) =>
  axios.patch(`${END_POINT}/${configId}`, payload);
const createDuration = (payload) => axios.post(`${END_POINT}`, payload);
const getConfig = () => axios.get(`${END_POINT}`);
export { changeDuration, getConfig, createDuration };
